import React from 'react';
import { CalendarEvent } from '../../types/ics';
import { getDaysInMonth, isSameDay } from '../../utils/dateUtils';
import { CalendarDay } from './CalendarDay';

interface CalendarGridProps {
  currentDate: Date;
  events: CalendarEvent[];
  onEventClick: (event: CalendarEvent) => void;
}

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const CalendarGrid: React.FC<CalendarGridProps> = ({ 
  currentDate, 
  events,
  onEventClick,
}) => {
  const days = getDaysInMonth(currentDate);
  
  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden">
      <div className="grid grid-cols-7 bg-gray-50">
        {WEEKDAYS.map((day) => (
          <div
            key={day}
            className="py-2 text-center text-sm font-semibold text-gray-600"
          >
            {day}
          </div>
        ))}
      </div>
      
      <div className="grid grid-cols-7">
        {days.map((date, index) => {
          const dayEvents = events.filter((event) =>
            isSameDay(event.startDate, date)
          );
          
          return (
            <CalendarDay
              key={index}
              date={date}
              events={dayEvents}
              isCurrentMonth={date.getMonth() === currentDate.getMonth()}
              onEventClick={onEventClick}
            />
          );
        })}
      </div>
    </div>
  );
};